import { useSyncExternalStore } from 'react';

/**
 * Estado de conectividad del navegador.
 *
 * `navigator.onLine` es optimista: dice true cuando hay interfaz de red,
 * aunque no haya internet real. Sirve para la UI (mostrar el banner),
 * NUNCA como condición para decidir si algo se encola o no — el outbox
 * encola siempre y reintenta. Ver ADR-003.
 */
function subscribe(onChange: () => void): () => void {
  globalThis.addEventListener('online', onChange);
  globalThis.addEventListener('offline', onChange);
  return () => {
    globalThis.removeEventListener('online', onChange);
    globalThis.removeEventListener('offline', onChange);
  };
}

function getSnapshot(): boolean {
  return globalThis.navigator?.onLine ?? true;
}

/** En SSR/prerender asumimos online: el banner no debe parpadear al hidratar. */
function getServerSnapshot(): boolean {
  return true;
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
